export const DESIGN = {
  colors: {
    background: '#f8f9ff',
    surface: '#ffffff',
    surfaceContainer: '#f2f3f9',
    surfaceContainerHigh: '#e7e8ee',
    outline: '#8a7170',
    outlineVariant: '#ddc0be',
    onBackground: '#191c20',
    onSurface: '#191c20',
    onSurfaceVariant: '#574241',

    primary: '#a43a3d',
    primaryContainer: '#ff7e7e',
    primaryFixed: '#ffdad8',
    onPrimary: '#ffffff',
    primaryDark: '#842228',

    secondary: '#006b5f',
    secondaryContainer: '#88f2e0',
    secondaryFixed: '#8bf5e3',
    onSecondary: '#ffffff',

    tertiary: '#705d00',
    tertiaryContainer: '#c3a300',
    tertiaryFixed: '#ffe173',
    onTertiary: '#ffffff',

    legendary: '#c3a300',
    rare: '#a43a3d',
    common: '#006b5f',

    success: '#00c853',
    fail: '#ff5252',
    nearMiss: '#ffab00',
    shadow: 'rgba(0,0,0,0.15)',
    glassWhite: 'rgba(255,255,255,0.5)',
  },

  fonts: {
    headline: 'Plus Jakarta Sans',
    body: 'Quicksand',
  },

  radius: {
    sm: 12,
    md: 16,
    lg: 24,
    xl: 32,
    full: 9999,
  },

  spacing: {
    xs: 4,
    sm: 8,
    md: 16,
    lg: 24,
    xl: 32,
  },

  machine: {
    width: 520,
    height: 640,
    cabinetPadding: 16,
    borderWidth: 8,
    clawY: 120,
    toyY: 520,
    dropY: 480,
    trackY: 180,
    minX: 220,
    maxX: 1060,
    targetX: 640,
  },
};

export const RARITY_COLORS = {
  common: DESIGN.colors.common,
  rare: DESIGN.colors.rare,
  legendary: DESIGN.colors.legendary,
};

export const RARITY_GLOWS = {
  common: 0x00c2a6,
  rare: 0xff6b6b,
  legendary: 0xffd700,
};
